import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Navigate } from "react-router-dom";
import { api } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => {
    if (user) api.put("/me/lang", { lang: localStorage.getItem("dbc_lang") === "ar" ? "ar" : "en" }).catch(() => {});
  }, [user?.email]); // eslint-disable-line react-hooks/exhaustive-deps

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, setUser, loading, refresh, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export const homeFor = (user) => (user?.has_admin_access ? "/admin" : "/me");

export const can = (user, perm) => !!user?.permissions?.includes(perm);

export const Protected = ({ anyPerm, children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen" data-testid="auth-loading" />;
  if (!user) return <Navigate to="/login" replace />;
  if (anyPerm && !anyPerm.some((p) => can(user, p))) return <Navigate to="/me" replace />;
  return children;
};
